import Vue from 'vue';
import VueRouter from 'vue-router';

import News from '../views/News.vue';
import NewsItem from '../views/NewsItem.vue';
import Home from '../views/Home.vue';
import Article from '../views/Article.vue';
import Articles from '../views/Articles.vue';
import Videos from '../views/Videos.vue';
import Video from '../views/Video.vue';
import Live from '../views/Live.vue';
import Match from '../views/Match.vue';
import Streams from '../views/Streams.vue';
import Stream from '../views/Stream.vue';
import Coaching from '../views/Coaching';
import CoachingSubscribe from '../views/CoachingSubscribe';
import CoachingCourses from '../views/CoachingCourses';

Vue.use(VueRouter);

const routes = [
	// News
	{path: '/news', name: 'news', component: News},
	{path: '/news/:id', name: 'news-item', component: NewsItem},
	
	// Articles
	{path: '/articles', name: 'articles', component: Articles},
	{path: '/articles/:id', name: 'article', component: Article},
	
	// Video
	{path: '/videos', name: 'videos', component: Videos},
	{path: '/videos/:id', name: 'video', component: Video},
	
	// Live
	{path: '/live/:sport', name: 'live', component: Live},
	
	// Match
	{path: '/match/:id', name: 'match', component: Match},
	
	// Streams
	{path: '/streams', name: 'streams', component: Streams},
	{path: '/streams/:id', name: 'stream', component: Stream},
	
	// Coaching
	{path: '/coaching', name: 'coaching', component: Coaching},
	{path: '/coaching/subscribe', name: 'coaching-subscribe', component: CoachingSubscribe},
	{path: '/coaching/courses', name: 'coaching-courses', component: CoachingCourses},
	
	// Home
	{path: '/', name: 'Home', component: Home},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

export default router;
